// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
const map = require('lodash/collection/map');
const { getLanguage } = require('core/i18n').i18n;

// @actions
const errorActions = require('actions/brokerError');

// @constants
const {
    BROKER_CONSULT_MIFID_FETCHING,
    BROKER_CONSULT_MIFID_FETCHING_SUCCESS,
    BROKER_CONSULT_MIFID_FETCHING_ERROR,
    BROKER_MIFID_VERSION_2
} = require('constants/actionTypes');

const {
    BROKER_CONSULT_RESULT_MIFID_FETCHING,
    BROKER_CONSULT_RESULT_MIFID_SUCCESS,
    BROKER_CONSULT_RESULT_MIFID_ERROR
} = require('mifid/constants/actionTypes');

const { CONVENIENCE_TEST_V3 } = require("constants/flagBasedFeatures");

const mifid2ToMifid1QuestionsAdapter = (mifid2Questions) => {
    return {
        preguntasArray: map(mifid2Questions, (question) => {
            return {
                id: get(question, 'id'),
                orden: get(question, 'orden'),
                descripcion: get(question, 'description'),
                respuestasArray: {
                    respuestasArray: map(get(question, 'answer'), (answer) => {
                        return {
                            id: get(answer, 'id'),
                            seleccionado: get(answer, 'selected'),
                            descripcion: get(answer, 'description')
                        };
                    })
                }
            };
        })
    };
};

const mifid2ToMifid1Adapter = (mifid2Response) => {
    const mifid2Questions = get(mifid2Response, 'test.question');

    return {
        result: {
            msg: 'OK', // (franco.montenegro) To confirm
            detalleErrorList: { detalleErrorList: null },
            id: get(mifid2Response, 'score.id') // (franco.montenegro) To confirm
        },
        fecha: get(mifid2Response, 'dateTest'),
        puntuacion: {
            descripcion: get(mifid2Response, 'score.description'),
            codigoDescripcion: get(mifid2Response, 'score.id'),
            value: get(mifid2Response, 'score.value')
        },
        preguntasArray: mifid2ToMifid1QuestionsAdapter(mifid2Questions)
    };
};

const consultMiFIDSuccess = (mifidVersion, response) => ({
    type: BROKER_CONSULT_MIFID_FETCHING_SUCCESS,
    payload: {
        response:
            mifidVersion === BROKER_MIFID_VERSION_2 ?
            mifid2ToMifid1Adapter(response) :
            response
    }
});

const consultMiFIDError = (error, history) => (dispatch) => {
    dispatch({
        type: BROKER_CONSULT_MIFID_FETCHING_ERROR,
        payload: { error }
    });

    const errorKey = get(error, ["body", "error"], ""); // (franco.montenegro) Confirm, will mifid 2 provide errors here?
    dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
};

const consultMiFID = (history, mifidVersion = BROKER_MIFID_VERSION_2) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const testV3FF = immFlagBasedFeatures.get(CONVENIENCE_TEST_V3)
    dispatch({
        type: BROKER_CONSULT_MIFID_FETCHING,
        payload: {}
    });

    const url =
        mifidVersion === BROKER_MIFID_VERSION_2 ?
        apiURLBuilder.getURL('brokerMiFIDGetTestByPerson') :
        apiURLBuilder.getURL('brokerMifidTestConvenienciaPorPersona');

    const requestData = {
        language: getLanguage().toLowerCase()
    };

    const query = mifidVersion === BROKER_MIFID_VERSION_2 ? {
        ...(testV3FF && {
            header: {
                version: 3
            }
        }),
        query: requestData
    } : {}

    return APIGet(dispatch, url, query).then(
        (response) => dispatch(consultMiFIDSuccess(mifidVersion, response)),
        (error) => dispatch(consultMiFIDError(error, history))
    );
};

const consultResultMiFIDSuccess = (response) => ({
    type: BROKER_CONSULT_RESULT_MIFID_SUCCESS,
    payload: response.getTestByPersonResponseListado
});

const consultResultMiFIDError = (error) => (dispatch) => {
    dispatch({
        type: BROKER_CONSULT_RESULT_MIFID_ERROR,
        payload: { error }
    });

    const errorKey = get(error, ["body", "error"], "");
    dispatch(errorActions.show("brokerAPIErrors-" + errorKey));
};

const consultResultMiFIDFetching = () => ({
    type: BROKER_CONSULT_RESULT_MIFID_FETCHING,
    payload: {}
});

const consultResultMiFID = () => (dispatch, getState) => {
    dispatch(consultResultMiFIDFetching());
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const testV3FF = immFlagBasedFeatures.get(CONVENIENCE_TEST_V3)
    const url = apiURLBuilder.getURL('brokerMiFIDGetTestByPerson')
    const numVersion = testV3FF ? 3 : 2;
    const requestData = {
      header: {
        version:  numVersion,
      },
      query: {
        language: getLanguage().toLowerCase()
      }
    };

  return APIGet(dispatch, url, requestData).then(
      (response) => dispatch(consultResultMiFIDSuccess(response)),
      (error) => dispatch(consultResultMiFIDError(error))
    );
};

module.exports = {
    consultResultMiFID,
    consultMiFID,
    mifid2ToMifid1Adapter
};
